export class WidgetStorage {
  private ns: string;

  constructor(tenant: string) {
    this.ns = `attende:${tenant}`;
  }

  get(key: string): string | null {
    try { return localStorage.getItem(`${this.ns}:${key}`); }
    catch { return null; }
  }

  set(key: string, value: string): void {
    try { localStorage.setItem(`${this.ns}:${key}`, value); }
    catch { /* quota exceeded — silently ignore */ }
  }

  remove(key: string): void {
    try { localStorage.removeItem(`${this.ns}:${key}`); }
    catch { /* ignore */ }
  }

  clear(): void {
    try {
      const keys: string[] = [];
      for (let i = 0; i < localStorage.length; i++) {
        const k = localStorage.key(i);
        if (k?.startsWith(this.ns + ':')) keys.push(k);
      }
      keys.forEach(k => localStorage.removeItem(k));
    } catch { /* ignore */ }
  }
}
